import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import BoltIcon from '@mui/icons-material/Bolt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LinkIcon from '@mui/icons-material/Link';

const actions = [
  { id: 'send', label: 'Send', icon: ArrowUpwardIcon, route: '/send-coin' },
  { id: 'receive', label: 'Receive', icon: QrCode2Icon, route: '/receive' },
  { id: 'buy', label: 'Buy', icon: BoltIcon, route: '/plans', featured: true },
  { id: 'sell', label: 'Sell', icon: AccountBalanceIcon, route: '/swap-coin' },
];

export default function MobileMenu() {
  return (
    <Box sx={{ px: 2, mt: 1, mb: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'flex-end' }}>
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <Box
              key={action.id}
              component={RouterLink}
              to={action.route}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'text.primary',
                flex: '1 1 0',
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  width: action.featured ? { xs: 52, sm: 64 } : { xs: 44, sm: 52 },
                  height: action.featured ? { xs: 52, sm: 64 } : { xs: 44, sm: 52 },
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 1,
                  bgcolor: action.featured ? 'primary.main' : 'action.hover',
                  color: action.featured ? '#fff' : 'text.primary',
                }}
              >
                <Icon />
              </Box>
              <Typography sx={{ fontSize: 12, fontWeight: 500 }}>{action.label}</Typography>
            </Box>
          );
        })}
      </Box>

      <Button
        component={RouterLink}
        to="/connect-wallet"
        fullWidth
        variant="contained"
        startIcon={<LinkIcon />}
        sx={{
          mt: 2,
          py: 1.4,
          borderRadius: 3,
          textTransform: 'none',
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        Link External Wallet
      </Button>
    </Box>
  );
}
